// studentSaga.js
import { call, put, takeLatest } from "redux-saga/effects";

import {
  FETCH_STUDENTS_REQUEST,
  ADD_STUDENT_REQUEST,
  UPDATE_STUDENT_REQUEST,
  DELETE_STUDENT_REQUEST,
  FETCH_STUDENT_PROFILE_REQUEST
} from "./actionTypes";

import {
  fetchStudentsSuccess,
  fetchStudentsFailure,
  addStudentSuccess,
  addStudentFailure,
  updateStudentSuccess,
  updateStudentFailure,
  deleteStudentSuccess,
  deleteStudentFailure,
   fetchStudentProfileSuccess,
  fetchStudentProfileFailure,
} from "./actions";

import axiosInstance from "pages/Utility/axiosInstance";
import { showSuccess } from "helpers/notification_helper";

// ---------------- API calls ---------------- //
const fetchStudentsApi = async (params) => {
  return await axiosInstance.get("V1/students", { params });
};

const addStudentApi = async (student) => {
  return await axiosInstance.post("V1/students", student);
};

const updateStudentApi = async ({ id, student }) => {
  return await axiosInstance.put(`V1/students/${id}`, student);
};

const deleteStudentApi = async (studentId) => {
  return await axiosInstance.delete(`V1/students/${studentId}`);
};

const fetchStudentProfileApi = async ({ id, params }) => {
  return await axiosInstance.get(`V1/students/student-profile/${id}`, { params });
};

// ---------------- Sagas ---------------- //

// Fetch students
function* fetchStudentsSaga(action) {
  try {
    const response = yield call(fetchStudentsApi, action.payload);
    yield put(fetchStudentsSuccess(response.data));
  } catch (error) {
    yield put(fetchStudentsFailure(error.message));
  }
}

// Add student
function* addStudentSaga(action) {
  try {
    const response = yield call(addStudentApi, action.payload.student);
    action.payload.onClose();
    yield put(addStudentSuccess(response.data));
    showSuccess("Student added successfully!");
  } catch (error) {
    yield put(addStudentFailure(error?.response?.data?.errors));
  }
}

// Update student
function* updateStudentSaga(action) {
  try {
    const response = yield call(updateStudentApi, action.payload);
    showSuccess(response?.data?.message);
    action.payload.onClose();
    yield put(updateStudentSuccess(response?.data));
  } catch (error) {
    yield put(updateStudentFailure(error?.response?.data?.errors));
  }
}

// Delete student
function* deleteStudentSaga(action) {
  try {
    const { data } = yield call(deleteStudentApi, action.payload);
    yield put(deleteStudentSuccess(data));
    showSuccess("Student deleted successfully!");
  } catch (error) {
    yield put(deleteStudentFailure(error.message));
  }
}

//Fetch student

function* fetchStudentProfileSaga(action) {
  try {
    const response = yield call(fetchStudentProfileApi, action.payload);
    yield put(fetchStudentProfileSuccess(response.data.data)); 
  } catch (error) {
    yield put(fetchStudentProfileFailure(error.message));
  }
}

// ---------------- Watcher saga ---------------- //
export default function* studentSaga() {
  yield takeLatest(FETCH_STUDENTS_REQUEST, fetchStudentsSaga);
  yield takeLatest(ADD_STUDENT_REQUEST, addStudentSaga);
  yield takeLatest(UPDATE_STUDENT_REQUEST, updateStudentSaga);
  yield takeLatest(DELETE_STUDENT_REQUEST, deleteStudentSaga);
  yield takeLatest(FETCH_STUDENT_PROFILE_REQUEST, fetchStudentProfileSaga);
}
